import { useAllLocalStorage } from '../useStorage/useAllLocalStorage'
import { ColorModeEnum } from './index'
import { useEffect, useState } from 'react'
import { getWindow } from '@ztechapps/common.utils'

export type UseColorModeResult = {
  colorMode: ColorModeEnum
  toggle: () => void
  enable: () => void
  disable: () => void
  isDark: boolean
}
export type UseColorModeProps = {
  initialize?: boolean
}
export const useColorMode = ({ initialize = false }: UseColorModeProps = {}): UseColorModeResult => {
  const ls = useAllLocalStorage()
  const doc = getWindow()?.document
  const colorModeKey = '__app-color-mode__'

  // Get colorMode from ls or default to "dark"
  const [colorMode, setColorMode] = useState<ColorModeEnum>(ls.get(colorModeKey) || ColorModeEnum.light)

  // Update the HTML attribute when color mode changes and when set to initialize
  useEffect(() => {
    if (initialize === true) {
      enable()
    }
  }, [initialize])

  // Toggle function
  const toggle = () => {
    const newColorMode = colorMode === ColorModeEnum.light ? ColorModeEnum.dark : ColorModeEnum.light
    setColorMode(newColorMode)
    enable(newColorMode)
  }

  const enable = (newColorMode?: ColorModeEnum) => {
    newColorMode = newColorMode ?? colorMode
    if (doc) doc.documentElement.setAttribute('data-bs-theme', newColorMode)
    ls.set(colorModeKey, newColorMode)
  }

  const disable = () => {
    if (doc) doc.documentElement.removeAttribute('data-bs-theme')
    ls.remove(colorModeKey)
  }

  const isDark = colorMode === ColorModeEnum.dark

  return {
    colorMode,
    toggle,
    enable,
    disable,
    isDark,
  }
}
